import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';

import { environment } from '@app/env-service';

import { Staff, Assignee } from '../store/staff.model';

@Injectable({
  providedIn: 'root',
})
export class ContactApiService {
  url :string = environment.url;

  constructor(private http :HttpClient) {}

  getList(params :{ [param :string] :string | string[] }) :Observable<any> {
    return this.http.get(`${environment.urlV2}/manage/contact-details`, {
      params,
    });
  }

  getFactoryContacts(factoryId :number) :Observable<any> {
    return this.http.get(
      `${environment.urlV2}/manage/contact-details/factory/${factoryId}`,
    );
  }
}
